import axios from 'axios';
import Logger from '../../utils/logger';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - handles auth token and request logging
apiClient.interceptors.request.use(
  (request) => {
    // Create a safe copy of the request for logging (excluding sensitive data)
    const safeRequest = { ...request };
    if (safeRequest.data && typeof safeRequest.data === 'object') {
      safeRequest.data = { ...safeRequest.data };
      // Redact all password-related fields
      const passwordFields = [
        'password',
        'current_password',
        'new_password',
        'check_password',
      ];
      passwordFields.forEach((field) => {
        if (safeRequest.data[field]) {
          safeRequest.data[field] = '[REDACTED]';
        }
      });
    }
    Logger.apiRequest(
      request.method,
      request.url,
      request.params,
      safeRequest.data
    );
    return request;
  },
  (error) => {
    Logger.apiError(
      error.config?.method || 'UNKNOWN',
      error.config?.url || 'UNKNOWN',
      error
    );
    return Promise.reject(error);
  }
);

// Response interceptor - handles response logging
apiClient.interceptors.response.use(
  (response) => {
    Logger.apiResponse(
      response.config.method,
      response.config.url,
      response.status,
      response.data
    );
    return response;
  },
  (error) => {
    Logger.apiError(
      error.config?.method || 'UNKNOWN',
      error.config?.url || 'UNKNOWN',
      error
    );
    return Promise.reject(error);
  }
);

/**
 * Get axios instance with auth token configured
 * @param {string} token - JWT authentication token
 * @returns {AxiosInstance} Configured axios instance
 */
export const getApiClient = (token) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
  return apiClient;
};

export default apiClient;
